module.exports = __webpack_public_path__ + "img/logo-cibim.97d6b706.svg";